export default __webpack_public_path__ + "static/media/zyngra.f7ccfee1.svg";